import gql from 'graphql-tag'

import {
  genericStructuredTextFragment
} from './structuredText.gql'

import {
  responsiveMediaFragment,
  type ResponsiveMedia
} from './mediaFragments.gql'

export const getOwnersGuideProducts = gql`query ProductsWithOwnersGuideArticles {
  allBaseProducts(filter: {baseProduct: {exists: false}}, first: "100") {
    id
    sku
    _allReferencingOwnersGuideArticlesMeta {
      count
    }
  }
}`

export type ProductWithOwnersGuideArticles = {
  id: string
  sku: string
  _allReferencingOwnersGuideArticlesMeta: {
    count: number
  }
}

export type ProductsWithOwnersGuideArticlesResponse = {
  allBaseProducts: ProductWithOwnersGuideArticles[]
}

export const getOwnersGuideArticles = gql`query GetOwnersGuideArticles($limit: IntType!, $offset: IntType!, $productID: ItemId!) {
  allOwnersGuideArticles(first: $limit, skip: $offset, filter: {products: {anyIn: [$productID]}}) {
    id
    title
    body {
      ${genericStructuredTextFragment}
    }
    slides {
      ${responsiveMediaFragment("image", null, true)}
      copy {
        value
      }
    }
  }
}`

export type OwnersGuideArticle = {
  id: string
  title: string
  body: {
    value: any
    blocks: {
      __typename: string
      _modelApiKey: string
      id: string
      video?: {
        url: string
        thumbnailUrl: string
        height: number
        width: number
        provider: string
        providerUid: string
        title: string
      }
    }[]
  }
  slides: {
    image: ResponsiveMedia
    copy: {
      value: any
    }
  }
}

export type GetOwnersGuideArticlesResponse = {
  allOwnersGuideArticles: OwnersGuideArticle[]
}